import x2js from 'x2js';

const xmlToJson = new x2js();

export const mockResponse = (type, payload) => {
    const method = type === 'application/json' ? 'json' : 'text';
    return {
        ok: true,
        headers: {
            get() {
                return type;
            }
        },
        [method]: () => payload,
    };
};

export const checkForError = (res) => {
    if (!res.ok) throw res;
    return res;
};

export const transformToJSON = (res) => {
    const contentType = res.headers && res.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
        return res.json();
    }

    return xmlToJson.xml2js(res.text())
}
